import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepTwoCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepTwoCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.discoverStepTwoCollections.data.discoverStepTwoCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.discoverStepTwoCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
